var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"link-arrow",attrs:{"to":_vm.href}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),_c('img',{attrs:{"src":require("@/assets/img/icons.svg") + "#icon-arrow","width":"14","height":"10"}})])}
var staticRenderFns = []

export { render, staticRenderFns }